import { Button, Card, Row, Col } from "react-bootstrap";
import IconSvg from "../../../SharedComponents/IconSvg";
import ApiHelper from "../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../Helpers/EnumHelper";
import { useTranslation } from "react-i18next";

export default function ImageUploader({ label, size, apiPath, typeEnumKey, existingPath, onDelete, hook }) {
  const { t } = useTranslation();
  const { preview, onFileChange, clear } = hook;

  const handleDelete = () => {
    clear();
    if (existingPath) {
      onDelete(typeEnumKey, existingPath);
    }
  };

  const src = preview || (existingPath ? ApiHelper.cloudFrontURL + folderEnum[apiPath] + existingPath : "");

  return (
    <Card className="default-card position-relative h-100">
      {src ? (
        <>
          <div className="logo-previev-img-container">
            <img src={src} alt={label} width={size.width} height={size.height} />
          </div>
          <Row className="absolute-top mx-0" style={{ width: "100%" }}>
            <Col>
              <h5 style={{ color: "gray", paddingTop: "5px" }}>{t(typeEnumKey)}</h5>
            </Col>
            <Col>
              <Row xs="auto" className="justify-content-md-end">
                <Button className="company-images-del-button" size="sm" variant="danger" onClick={handleDelete}>
                  <IconSvg icon="trash-can" fill="#fff" />
                </Button>
              </Row>
            </Col>
          </Row>
        </>
      ) : (
        <label className="admin-setting-page-add-image-label h-100">
          <input id="admin-excel-input" type="file" accept=".jpeg,.png,.webp,.jpg" onChange={onFileChange} />
          <IconSvg icon="add-image" />
          {label} ({size.width}×{size.height})
        </label>
      )}
    </Card>
  );
}
